import {
  Skeleton as BackyardSkeleton,
  Flex,
  SkeletonProps
} from '@backyard-ui/core'

const SkeletonBase = (props: SkeletonProps) => (
  <BackyardSkeleton
    {...props}
    UNSAFE_className={`${props.UNSAFE_className} bg-white`}
  />
)

export function SkeletonTitle() {
  return (
    <Flex direction="column" className="w-full gap-2">
      <SkeletonBase width="auto" height="14px" radius="2xl" />
      <SkeletonBase width="280px" height="12px" radius="2xl" />
      <SkeletonBase width="100%" height="56px" radius="2xl" />
      <SkeletonBase width="110px" height="24px" radius="2xl" />
    </Flex>
  )
}

export function SkeletonDescription() {
  return (
    <div className="w-full h-full px-2 overflow-hidden md:px-8">
      {new Array(3).fill(null).map((_, index) => (
        <Flex key={index} className="w-full gap-3" data-testid="skeleton-item">
          <div>
            <SkeletonBase width="40px" height="40px" radius="full" />
          </div>
          <div className="w-full">
            <Flex direction="column" className="w-full gap-2 mb-6">
              <SkeletonBase width="100px" height="12px" radius="lg" />
              <SkeletonBase width="225px" height="75px" radius="lg" />
            </Flex>
            <Flex direction="column" className="w-full gap-2 mb-6 items-end">
              <SkeletonBase width="100px" height="12px" radius="lg" />
              <SkeletonBase width="225px" height="75px" radius="lg" />
            </Flex>
          </div>
        </Flex>
      ))}
    </div>
  )
}

export function SkeletonFooter() {
  return (
    <div className="w-full h-full p-4 bg-gray-200 rounded-b-xl">
      <Flex className="w-full gap-4">
        <SkeletonBase width="38px" height="38px" radius="lg" />
        <SkeletonBase
          width="auto"
          height="38px"
          radius="lg"
          UNSAFE_className="flex-1"
        />
        <SkeletonBase width="38px" height="38px" radius="full" />
      </Flex>
    </div>
  )
}
